import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const MAINT_REPORT_PATH = 'api/MaintenanceReport';

export const getMaintReportsGrid = (params) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/Grid${getQueryParams(params)}`),
);

export const getMaintReportsBuckets = (params) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/Buckets${getQueryParams(params)}`),
);

// Maint Report item

export const getMaintReportById = (maintReportId) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/${maintReportId }`),
);

export const saveMaintReport = (maintReportId, data) => makeRequest(
  authFetch.put(`${MAINT_REPORT_PATH}/${maintReportId }`, data),
);

export const completeMaintReport = (maintReportId) => makeRequest(
  authFetch.post(`${MAINT_REPORT_PATH}/${maintReportId }/Complete`),
);

// Status History
export const getMaintReportStatusHistoryById = (maintReportId) => makeRequest(
  authFetch.get(`api/MaintenanceReportStatusHistory/${maintReportId}`),
);

// Maint Report Records
export const getMaintRecordsById = (maintReportId) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/${maintReportId}/Records`),
);

export const saveMaintRecord = (maintReportId, data) => makeRequest(
  authFetch.put(`${MAINT_REPORT_PATH}/${maintReportId}/Records`, data),
);

export const deleteMaintRecord = ({ maintReportId, recordId }) => makeRequest(
  authFetch.delete(`${MAINT_REPORT_PATH}/${maintReportId}/Records/${recordId}`),
);

export const approveMaintRecord = ({ maintReportId, recordId }) => makeRequest(
  authFetch.patch(`${MAINT_REPORT_PATH}/${maintReportId}/Records/${recordId}/Approve`),
);

export const rejectMaintRecord = ({ maintReportId, recordId, rejectReason }) => makeRequest(
  authFetch.patch(`${MAINT_REPORT_PATH}/${maintReportId}/Records/${recordId}/Reject`, rejectReason),
);

// Audit
export const getMaintReportAudits = (maintReportId, params) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/${maintReportId}/Audits${getQueryParams(params)}`),
);

export const getMaintReportAuditProperties = (maintReportId) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/${maintReportId}/Audits/Properties`),
);

export const getMaintReportAuditUsers = (maintReportId) => makeRequest(
  authFetch.get(`${MAINT_REPORT_PATH}/${maintReportId}/Audits/Users`),
);

// Lookups/Statics

export const getMaintReportStatuses = () => makeRequest(authFetch.get(`${MAINT_REPORT_PATH}/statusesLookup`));

export const getMaintReportsYears = () => makeRequest(authFetch.get(`${MAINT_REPORT_PATH}/YearsLookup`));
